import { useTranslation } from 'react-i18next'

import { EyeIcon } from '@phosphor-icons/react'

import AnimatedNumber from '@/common/components/AnimatedNumber/AnimatedNumber'
import { statisticStatuses } from '@/common/components/Statistic/constants'
import Statistic from '@/common/components/Statistic/Statistic'

import { transactionsAnalyticsStatsValues } from '../constants'

const ForReview = ({ forReview, onClick }) => {
  const { t } = useTranslation()

  return (
    <Statistic
      size="small"
      isOutlined={false}
      status={statisticStatuses.warning}
      Icon={EyeIcon}
      label={t('Por revisar')}
      value={<AnimatedNumber target={forReview} format="decimal" />}
      showStatusIcon
      onClick={() => onClick(transactionsAnalyticsStatsValues.forReview)}
    />
  )
}

export default ForReview
